import axios from 'axios'

const BASE_URL = process.env.VUE_APP_BASE_URL

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Api-key': process.env.VUE_APP_API_KEY,
  },
  timeout: 0,
})

api.interceptors.request.use(config => {
  const token = sessionStorage.getItem('token')

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

export default api